import { useAsync } from 'react-use';
import { SilentAuthError } from '@spotify-internal/oauth-silent-authentication';

import * as Sentry from 'lib/client/sentry/sentry';
import { ErrorMessage } from 'containers/ContentReporting/ContentPolicyReporting/utils/types';
import { SP_API_URL } from 'lib/shared/config/config';
import auth from 'lib/shared/auth/auth';

export const useUserData = () => {
  const { value, loading, error } = useAsync(async (): Promise<SpotifyApi.CurrentUsersProfileResponse> => {
    try {
      const response = await auth.fetch(`${SP_API_URL}/v1/me`, {});
      if (response.ok) {
        const data = await response.json();

        return data;
      }

      Sentry.captureException(`Called "${SP_API_URL}/v1/me", Code: ${response.status}; Payload: ${response.body}`);
    } catch (e: unknown) {
      const silentAuthError = e as SilentAuthError;
      // /v1/me API returns an error if the user is not logged in
      if (silentAuthError.error !== 'login_required') {
        Sentry.captureException(`Error under useUserData: ${JSON.stringify(e)}`);
      }
    }
    return Promise.reject(ErrorMessage.CONTENT_REQUEST_ERROR);
  }, []);

  return {
    isLoading: loading,
    error,
    userData: value,
  };
};

export default useUserData;
